<div class="row mb-2">
    <div class="col pl-0">
        <div widget class="card border-0 box-shadow">
            <div class="card-header transparent  text-muted">
                <!-- Add Manual Timesheets -->
                <div class="row">
                    <div class="col-lg-6">
                        <h4 class="mb-0 font-header">Add Manual Timesheets</h4>
                    </div>
                  
                    <div class="col-lg-6">
                        <div class="ms-lg-5 ps-lg-5">
                        <h5 class="notealert float-start">Note:Rows in red color has Timesheets already on that date</h5>
                    </div>
                </div>
                </div>
            </div>
            <div class="card-body  widget-body pb-0 pt-2 mb-4">
                <!-- row 1 -->
                <div class="row">
                    <div class="col-lg-5" style="border-right: solid 2px #502189;">
                        <!-- Client Name -->
                        <div class="row ">
                            <div class="col-lg-4">
                                <label>Client
                                    Name</label>
                            </div>
                            <div class="col-lg-8">
                                <ng-select [searchable]="true" [(ngModel)]="ClientEditFilter" [clearable]="true"
                                    (ngModelChange)="GetMappedEmployees();GetcheckedTimesheets();
                                  clearFields()" bindLabel="Value" bindValue="Key"
                                    [items]="EditInputProperty.ClientList" class="w-100">
                                    <!-- GetEmployeePayrate -->
                                </ng-select>
                            </div>
                        </div>
                        <!-- Employee Name -->
                        <div class="row mt-3">
                            <div class="col-lg-4">
                                <label>Employee
                                    Name</label>
                            </div>
                            <div class="col-lg-8">
                                <ng-select [searchable]="true" [(ngModel)]="EmployeeEditFilter"
                                    (ngModelChange)="getRelationship();GetcheckedTimesheets();"
                                    [disabled]="ClientEditFilter==null || ClientEditFilter==undefined || ClientEditFilter==''"
                                    [clearable]="true" bindLabel="employeeName" bindValue="employeeId"
                                    [items]="EmployeeMappedList" class="w-100">
                                    <!-- GetEmployeePayrateForClient(); -->
                                </ng-select>
                            </div>
                        </div>
                        <!-- Relationship -->
                        <div class="row mt-3">
                            <div class="col-lg-4">
                                <label>Relationship</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" [(ngModel)]="RelationshipEditFilter" class="w-100" disabled>
                            </div>
                        </div>
                        <!-- start Date -->
                        <div class="row mt-3">
                            <div class="col-lg-4">
                                <label>Start
                                    Date</label>
                            </div>
                            <div class="col-lg-8">
                                <my-date-picker [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                 [disabled]="ClientEditFilter==null || ClientEditFilter==undefined || ClientEditFilter==''||
                                    
                                    EmployeeEditFilter==null || EmployeeEditFilter==undefined || EmployeeEditFilter==''
                                    " [selDate]="FromDateFilter"
                                    (inputFieldChanged)="DateFormat($event,'inputchanged','SaveFromDate')"
                                    (dateChanged)="DateFormat($event,'datechanged','SaveFromDate')" >
                                </my-date-picker>
                            </div>
                        </div>
                        <!-- End Date -->
                        <div class="row mt-3">
                            <div class="col-lg-4">
                                <label>End
                                    Date</label>
                            </div>
                            <div class="col-lg-8">
                                <my-date-picker [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                 [disabled]="ClientEditFilter==null || ClientEditFilter==undefined || ClientEditFilter==''||
                                    EmployeeEditFilter==null || EmployeeEditFilter==undefined || EmployeeEditFilter==''
                                    " [selDate]="EndDateFilter"
                                    (inputFieldChanged)="DateFormat($event,'inputchanged','SaveEndDate')"
                                    (dateChanged)="DateFormat($event,'datechanged','SaveEndDate')">
                                </my-date-picker>
                            </div>
                        </div>
                        <!-- Authorization Service -->
                        <div class="row mt-3">
                            <div class="col-lg-4">
                                <label>Authorization Service</label>
                            </div>
                            <div class="col-lg-8">
                                <ng-select [searchable]="true" [(ngModel)]="ServiceEditFilter" [clearable]="true" 
                                    bindLabel="fields" bindValue="id" disabled [items]="ActiveAuthorizationList"
                                    class="w-100">
                                </ng-select>
                            </div>
                        </div>
                        <!-- Balance Amount -->
                        <div class="row mt-3">
                            <div class="col-lg-4">
                                <label>Remaining Amount</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" [(ngModel)]="RemainingAmountEditFilter" class="w-100" disabled>
                            </div>
                        </div>
                        <!-- Payor -->
                        <div class="row mt-3">
                            <div class="col-lg-4">
                                <label>Payor</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" [(ngModel)]="PayorEditFilter" class="w-100" disabled>
                            </div>
                        </div>
                        <!-- Rate -->
                      
                    </div>
                    <!-- Authorization Details -->
                    <div class="col-lg-7">
                        <div class="row">
                            <label class="subtablelabel mt-3" *ngIf="isAuthorizationDetails">Authorization
                                Details</label>
                            <label class="subtablelabel mt-3 text-center" *ngIf="isNoAuthorizationDetails"
                                style="font-weight: bold;">No Authorization
                                Details</label>
                        </div>
                        <div class="row" *ngIf="isAuthorizationDetails">
                            <div class="col-lg-12">
                                <ejs-grid #gridActiveAuthorization [dataSource]='ActiveAuthorizationList'
                                    [rowHeight]='40' [pageSettings]='AuthorizationinitialPage' [allowPaging]='true'
                                    (queryCellInfo)='customiseCell($event)' (rowSelected)='rowSelected($event)'
                                    [allowResizing]='true'>
                                    <e-columns>
                                         <!-- startdate -->
                                         <e-column field="startDate" headerText="Start Date" minWidth=120 
                                         [format]='formatOptions' type="date">
                                             <ng-template #filterTemplate let-row>
                                             </ng-template>
                                         </e-column>
                                         <!-- enddate -->
                                         <e-column field="endDate" headerText="End Date" minWidth=120 [format]='formatOptions' type="date">
                                             <ng-template #filterTemplate let-row>
                                             </ng-template>
                                         </e-column>
                                        <!-- Service -->
                                        <e-column minWidth=100 field="fields" headerText="Service">
                                            <ng-template #filterTemplate let-row>
                                            </ng-template>
                                        </e-column>
                                         <!--AuthNote  -->
                                        <e-column minWidth=100 field="authNote" headerText="Auth Note">
                                            <ng-template #filterTemplate let-row>
                                            </ng-template>
                                        </e-column>
        
                                         <!-- serviceGroup -->
                                         <e-column minWidth=100 field="serviceGroup" headerText="Service Group">
                                            <ng-template #filterTemplate let-row>
                                            </ng-template>
                                        </e-column>



                                        
                                        <!-- BalanceAmount -->
                                        <e-column field="balanceAmount" headerText="Remaining Amount" minWidth=120>
                                            <ng-template #filterTemplate let-row>
                                            </ng-template>
                                        </e-column>
                                       

                                        <!-- Payor -->
                                        <e-column field="payor" headerText="Payor" minWidth=120>
                                            <ng-template #filterTemplate let-row>
                                            </ng-template>
                                        </e-column>
                                        <!-- Rate -->
                                        <e-column minWidth=100 field="rate" headerText="Rate">
                                            <ng-template #filterTemplate let-row>
                                            </ng-template>
                                        </e-column>
                                        <e-column minWidth=100 field="insuranceNumber" headerText="Insurance Number">
                                            <ng-template #filterTemplate let-row>
                                            </ng-template>
                                        </e-column>
                                     


                                    </e-columns>
                                </ejs-grid>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- row 2 -->
                <div class="row pt-3">
                    <div class="col-lg-5">
                    </div>
                    <div class="col-lg-7 ">
                        <div class="row">
                            <label class="col-lg-4 ">Add Bulk Hours(per day) </label>
                            <div class="col-lg-6 mb-3"> <input *ngIf="!isTransportation" type="text" class="form-control"
                                    [(ngModel)]="AllTotalhours" (keypress)="numberonly($event,'All')">
                                    <input type="text" *ngIf="isTransportation" class="form-control"
                                    [(ngModel)]="AllTotalhours" (keypress)="numbersOnlyS2015Validation($event,'All')">
                                </div>
                                    
                            <div class="col-lg-2"><button type="button" class="btn blue-btn btn-sm"
                                    (click)="ApplyTotalHours(); CheckHoursExceeds()" [disabled]="TimesheetOrderList.length==0 ||
                                    AllTotalhours==null || AllTotalhours==undefined || AllTotalhours==''">
                                    Apply</button>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <!-- Tables -->
                        <table class="table  table-hover " style="margin-top: 3px;">
                            <tr style=" background-color:  #502189 !important;height: 32px">
                                <th class="pointer" class="text-center" style="background-color: #502189;color:#fff ">Services
                                </th>
                                <th class="pointer" class="text-center font-color">Day
                                </th>
                                <th class="pointer" class="text-center font-color">Date
                                </th>
                                <th class="pointer" class="text-center font-color">Rate
                                </th>
                                <th class="pointer" class="text-center font-color">Hours
                                </th>

                                <th class="pointer" class="text-center font-color">Amount
                                </th>
                            </tr>
                            <tbody>
                                <tr *ngFor="let assignTimesheetDetails of TimesheetOrderList;let TimesheetIndex=index"
                                    [ngStyle]="{'background-color': (assignTimesheetDetails.isHighlighted == true)?'#ff8590': 'white'}">
                                    <td class="text-center" tabindex="-1"
                                        [ngStyle]="{'color':'black'}">
                                        {{assignTimesheetDetails.Authorizationservice}}
                                    </td>
                                    <td class="text-center" tabindex="-1"
                                        [ngStyle]="{'color':'black'}">
                                        {{assignTimesheetDetails.Days}}
                                    </td>
                                    <td class="text-center" tabindex="-1"
                                        [ngStyle]="{'color':'black'}">
                                        {{assignTimesheetDetails.timesheetDate}}
                                    </td>
                                    <td class="text-center" tabindex="-1"
                                        [ngStyle]="{'color':'black'}">
                                        {{assignTimesheetDetails.Rate}}
                                    </td>
                                    <td class="text-center" [attr.contenteditable]="true" *ngIf="!isTransportation"
                                        [ngStyle]="{'color':'black'}"
                                        (keypress)="numberonly($event,'create')"
                                        (focusout)="saveTimesheethours($event,TimesheetIndex,TimesheetOrderList)"
                                        id="editable_div{{TimesheetIndex}}">
                                        {{assignTimesheetDetails.hours}}
                                    </td>
                                    <td class="text-center" [attr.contenteditable]="true" *ngIf="isTransportation"
                                    [ngStyle]="{'color':'black'}"
                                    (keypress)="numbersOnlyS2015Validation($event,'create')"
                                    (focusout)="saveTimesheethours($event,TimesheetIndex,TimesheetOrderList)"
                                    id="editable_div{{TimesheetIndex}}">
                                    {{assignTimesheetDetails.hours}}
                                </td>
                                    <td class="text-center" tabindex="-1"
                                        [ngStyle]="{'color':'black'}">
                                        {{assignTimesheetDetails.totalAmount}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <!-- save buttons -->
                <div class="row">
                    <div class="col-lg-6">
                        <label>
                            Entered Total Hours :{{enteredhour}} hrs &nbsp;&nbsp;{{enteredminutes}} mins
                        </label>
                    </div>
                    <div class="col-lg-5 text-end">
                        <label>
                            Total Amount :{{showTotalamount}}
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6">
                    </div>
                    <div class="col-lg-6 mt-3">
                        <div class="row" class="timesheet-footer">
                            <button class="btn  blue-btn btn-sm  savealign" [disabled]="ClientEditFilter==null || ClientEditFilter==undefined || ClientEditFilter=='' ||
                            EmployeeEditFilter==null || EmployeeEditFilter==undefined || EmployeeEditFilter=='' ||
                            ServiceEditFilter==null || ServiceEditFilter==undefined || ServiceEditFilter=='' || 
                            
                            FromDateFilter==null || FromDateFilter==undefined || FromDateFilter=='' ||
                            
                            EndDateFilter==null || EndDateFilter==undefined || EndDateFilter=='' || IsButtonDisable"
                                (click)="SaveTimesheets()">Save
                                & Close</button>
                            <button class="btn  blue-btn btn-sm savealign"
                                (click)="backtoTimesheetList()">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Insufficient Balance -->
<span id="openValidationModal" data-bs-toggle="modal" data-bs-target="#Validationmodal"></span>
<div class="modal fade" id="Validationmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog create-update-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Insufficient Balance</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="cancelValidation()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <p>Entered Amount will exceed the remaining budget amount.
                            Are you sure you want to save?</p>

                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn  btn-sm" data-bs-dismiss="modal" (click)="exceedTaxAmount();">
                    <span> Yes
                    </span> </button>
                <button type="button" class="btn  btn-sm" data-bs-dismiss="modal"
                    (click)="cancelValidation()">No</button>
            </div>
        </div>
    </div>
</div>

<span id="taxExceedModal" data-bs-toggle="modal" data-bs-target="#TaxValidationmodal"></span>
<div class="modal fade" id="TaxValidationmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog " role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header"><b>Warning!</b></h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="cancelValidation()">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12"   >
                        <p class="err" style="text-align:center;font-size:1.2rem;" *ngIf="EmployerTax && HavingTax && TaxPercentAmount !=null && TaxPercentAmount !=undefined && TaxPercentAmount != '' || taxAvailbleInClientTab || taxAvailbleInTaxTab " >Insufficent Tax Amount!
                            </p>
                    <ul class="roof">
                        <li *ngIf="!EmployerTax"> <p class="err p-1" >Tax Authorization Not Found  </p></li>
                        <li *ngIf="!HavingTax" ><p class="err p-1"  > No Tax Found in RelationShip  </p></li>
                        <li  *ngIf="TaxPercentAmount ==null || TaxPercentAmount == undefined || TaxPercentAmount == 0 || (!taxAvailbleInTaxTab && !taxAvailbleInClientTab)" > <p class="err p-1"  > No Tax Percent Found   </p></li>
                    </ul>
                     </div>
                </div>
            </div>
            <div class="modal-footer d-flex justify-content-between">
                <p><span><b> Do You Want To Continue? </b></span></p>
              <span>  <button class="btn  btn-sm me-2" data-bs-dismiss="modal" (click)="taxSaving()">
                <span> Yes
                </span> </button>
                <button type="button"  class="btn  btn-sm ms-2" data-bs-dismiss="modal"
                (click)="cancelValidation()">No</button></span>
            </div>
        </div>
    </div>
</div>

